<template>
    <!-- input组件 -->
    <div class="vel-input">
        <el-input
        v-if="!showAutocomplete"
        v-model="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :clearable="clearable"
        :show-password="showPassword"
        :prefix-icon="beforeIcon"
        :suffix-icon="afterIcon"
        :type="type"
        :rows="rows"
        :autosize="autosize"
        :size="size"
        :maxlength="maxlength"
        :show-word-limit="showLimit"
        :minlength="minlength"
        :autocomplete="autocomplete"
        :name="name"
        :readonly="readonly"
        :max="max"
        :min="min"
        :step="step"
        :resize="resize"
        :autofocus="autofocus"
        :form="form"
        :label="label"
        :tabindex="tabindex"
        @focus="focus"
        @input="input"
        @change="change"
        @blur="blur"
        @clear="clear"
        >   
            <!-- 前置图标插槽 -->
            <template v-slot:prefix>
                <slot name="beforeIcon"></slot>
            </template>
            <!-- 后置图标插槽 -->
            <template v-slot:suffix>
                <slot name="afterIcon"></slot>
            </template>
            <!-- 前置文字插槽 -->
            <template v-slot:prepend>
                <slot name="beforeText"></slot>
            </template>
            <!-- 后前置文字插槽 -->
            <template v-slot:append>
                <slot name="afterText"></slot>
            </template>
        </el-input>
        <!-- 建议input -->
        <el-autocomplete
        v-else
        v-model="value"
        :fetch-suggestions="querySearch"
        :placeholder="placeholder"
        :clearable="clearable"
        :popper-class="popperClass"
        :disabled="disabled"
        :value-key="valueKey"
        :debounce="debounce"
        :placement="placement"
        :isOnfocus="onfocus"
        :isSelectUnmatched="selectUnmatched"
        :isHadeLoading="hadeLoading"
        :isHighlightFirstItem="highlightFirstItem"
        :prefix-icon="beforeIcon"
        :suffix-icon="afterIcon"
        :label="label"
        :name="name"
        @change="change"
        @select="select"
        >
            <!-- 前置图标插槽 -->
            <template v-slot:prefix>
                <slot name="beforeIcon"></slot>
            </template>
            <!-- 后置图标插槽 -->
            <template v-slot:suffix>
                <slot name="afterIcon"></slot>
            </template>
            <!-- 前置文字插槽 -->
            <template v-slot:prepend>
                <slot name="beforeText"></slot>
            </template>
            <!-- 后前置文字插槽 -->
            <template v-slot:append>
                <slot name="afterText"></slot>
            </template>
            <!-- 定义模板插槽 -->
            <template slot-scope="{item}">
                <slot :item="item"></slot>
            </template>
        </el-autocomplete>
    </div>
</template>
<script>
export default {
    name:"VelInput",
    props:{
        initValue:[String,Boolean,Number],
        placeholder:{
            type:String,
            default:'请输入'
        },
        beforeIcon:String,
        afterIcon:String,
        type:String,
        rows:Number,
        autosize:[Object,Boolean],
        size:String,
        popperClass:String,
        maxlength:Number,
        minlength:Number,
        autocomplete:{
            type:String,
            default:'on'
        },
        name:String,
        max:Number,
        min:Number,
        step:Number,
        resize:String,
        form:String,
        label:String,
        tabindex:String,
        valueKey:String,
        debounce:Number,
        placement:String,
        isOnfocus:Boolean,
        isSelectUnmatched:Boolean,
        isHadeLoading:Boolean,
        isHighlightFirstItem:Boolean,
        isShowAutocomplete:Boolean,
        isDisable:Boolean,
        isClearable:Boolean,
        isPassword:Boolean,
        isReadonly:Boolean,
        isAutofocus:Boolean,
        isLimit:Boolean,
    },
    data() {
        return {
            value:'',
            disabled:false,
            clearable:true,
            showPassword:false,
            readonly:false,
            autofocus:false,
            selectUnmatched:false,
            hadeLoading:false,
            highlightFirstItem:false,
            onfocus:false,
            showAutocomplete:false,
            showLimit:false,
        };
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        initDataFn(){
            this.isDisable ? this.disabled = true : this.disabled
            this.isOnfocus ? this.onfocus = true : this.onfocus
            this.isSelectUnmatched ? this.selectUnmatched = true : this.selectUnmatched
            this.isHadeLoading ? this.hadeLoading = true : this.hadeLoading
            this.isHighlightFirstItem ? this.highlightFirstItem = true : this.highlightFirstItem
            this.isShowAutocomplete ? this.showAutocomplete = true : this.showAutocomplete
            this.isClearable ? this.clearable = false : this.isClearable
            this.isPassword ? this.showPassword = true : this.showPassword
            this.isReadonly ? this.readonly = true : this.readonly
            this.isAutofocus ? this.autofocus = true : this.autofocus
            this.isLimit ? this.showLimit = true : this.showLimit
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = ''
        },
        focus(){
            this.$emit('focus')
        },
        change(val){
            this.$emit('change',val)
        },
        blur(){
            this.$emit('blur')
        },
        input(val){
            this.$emit('input',val)
        },
        clear(){
            this.$emit('clear')
        },
        querySearch(queryString, cb){
            this.$emit('querySearch',queryString,cb)
        },
        select(item){
            this.$emit('select',item)
        },
    }
}
</script>
<style scoped>
.vel-input{
    width: 100%;
}
</style>